export const defaults = {
	limit: Number.MAX_SAFE_INTEGER,
	maxScore: Number.MAX_SAFE_INTEGER,
	debug: false,
};
